module.exports = __webpack_public_path__ + "img/gr.03413af1.svg";